import * as React from "react";
import moment from "moment";
import "./FacesheetHousehold.scss";
import { getFormattedNameFromObject } from "../../services/stringService";
import { getCountableAndNonCountablePersons } from "../../services/magiServices";

const getAge = dob => {
    const dateOfBirth = moment(dob);
    return moment().diff(dateOfBirth.format("LL"), "years");
};

const FacesheetHouseholdMember = ({ member, expectedChildren }) => {
    let age = 0;
    if (member.dob) {
        age = getAge(member.dob);
    } else {
        age = getAge(member.dateOfBirth);
    }
    return (
        <div className="facesheet-household__card">
            <h4 className="facesheet-household__name">
                {getFormattedNameFromObject(member)} ({member.relationshipToPatient})
            </h4>
            <p className="facesheet-household__age">
                <span className="h5">Age:</span> {age}
            </p>
            {member.gender === "Female" && age > 13 && (
                <p className="facesheet-household__children">
                    <span className="h5">Expected Children:</span> {expectedChildren}
                </p>
            )}
        </div>
    );
};

export const FacesheetHousehold = ({ interviewHouseholdMembers, screenings, magiHousehold }) => {
    const getExpectedChildren = member => {
        const value = member.pregnancy?.expectedChildren;
        return value || 0;
    };

    const { countable, nonCountable } = getCountableAndNonCountablePersons(interviewHouseholdMembers, magiHousehold);

    return (
        <div className="facesheet-household">
            <div className="household-group">
                <h3>Countable</h3>
                <div className="household-members">
                    {countable.map((member, i) => (
                        <FacesheetHouseholdMember
                            member={member}
                            expectedChildren={getExpectedChildren(member)}
                            key={i}
                        />
                    ))}
                </div>
            </div>

            {nonCountable.length > 0 && (
                <div className="household-group">
                    <h3>Non Countable</h3>
                    <div className="household-members">
                        {nonCountable.map((member, i) => (
                            <FacesheetHouseholdMember
                                member={member}
                                expectedChildren={getExpectedChildren(member)}
                                key={i}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
